/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import FileModal from "components/FileModal";
import BrokingSummary from "components/BrokingSummary";
import DialogComponent from 'components/Dialog';
import TextField from 'components/Form/TextField';
import { Col } from 'components/Grid';
import TagsList3 from "components/TagList3";
import { ContentTextarea, DialogConfirm, DialogRejected, TextArea2 } from "./styles";
import StepNavigation from "components/StepNavigation/index";
import * as yup from 'yup';
import HasPermission from "components/HasPermission/index";
import Loader from 'components/Loader/index';
import Colors from 'constants/Colors';

export default function ApprovalPolicyPack(props) {
  const [file, setFile] = useState();
  const [summary, setSummary] = useState({});
  const [attachmentFile, setAttachmentFile] = useState({});
  const [scheduleAssumptionsFile, setScheduleAssumptionsFile] = useState({});
  const [wordingFile, setWordingFile] = useState({});
  const [userComments, setUserComments] = useState(null);
  const [isReject, setIsReject] = useState(false);
  const [rejectDocuments, setRejectDocuments] = useState([]);
  const [historymsg, setHistorymsg] = useState([]);
  const [wordingAttachmentFile, setWordingAttachmentFile] = useState({});
  const [endorsmentType, setEndorsmentType] = useState("");
  const [hideButtons, setHideButtons] = useState(false);
  const [isBound, setIsBound] = useState(false);
  const [idProduct, setIdProduct] = useState(null);

  const authContext = useContext(GlobalAuthContext);
  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const isClient = authContext.enumProfile === 1 ? true : false;
  const validation = yup.object().shape({});

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${new Date(message.approvalDate).toString()}
        ${message.approvalComments}
  
`;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }
  };

  const [typeDialog, setTypeDialog] = useState(null);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });

  function handleCancel() {
    setUserComments("");
    setDialog({
      visible: false,
      title: '',
      icon: 'exclamation',
      args: null
    })
  }

  function handleDialog(type) {
    if (type === "Approve") {
      setTypeDialog("Approve");
      setDialog({
        visible: true,
        title: !endorsmentType ? "APPROVE POLICY PACK REQUEST" : "APPROVE ENDORSEMENT PACK",
        icon: "TimesCircle",
        args: null,
      })
    } else {
      setTypeDialog("Reject");
      setDialog({
        visible: true,
        title: !endorsmentType ? "REJECT POLICY PACK REQUEST" : "REJECT ENDORSEMENT PACK",
        icon: "TimesCircle",
        args: null,
      })
    }
  };

  function handleApproval() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingBrokerSrApprove(props.match.params.idOperation, userComments)
      .then(response => response.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          loading.stop();
          if (endorsmentType && endorsmentType !== "declaration") {
            return history.push('/policies');
          } else {
            return history.push('/list');
          }
        } else {
          mc.error(resp.ret_msg_details);
          loading.stop();
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleApproval.name}\n` + error);
        console.error('fitPostAproval - Error:', error);
        loading.stop();
      })
  };

  function handleReject() {
    loading.start();
    handleImport();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingBrokerSrReject(props.match.params.idOperation, userComments)
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          loading.stop();
          mc.success("Approval Policy Pack Rejected");
          if (!endorsmentType) return history.push('/list');
          return history.push('/policies');
        } else {
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleReject.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
  };

  function handleSummary() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json())
      .then(data => {
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          operationStatus: data.ret_value.idOperation,
          idDomainStatusPolicyPack: data.ret_value.idDomainStatusPolicyPack,
          idOperation: props.match.params.idOperation,
        });
        setEndorsmentType(data.ret_value.endorsmentType);
        //hideActionsButtons(data.ret_value.idDomainStatusPolicyPack);
        setHistorymsg(data.ret_value.historical);
        if (data.ret_value.policyPackMessage && formik.current) {
          formik.current?.setFieldValue('policyPackMessage', data.ret_value.policyPackMessage);
        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
    loading.stop();
  };

  function handleGetModal() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingHtmlModal(props.match.params.idOperation)
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          setFile(resp.ret_value.policePackReturnDocs)
        } else {
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetModal.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
    loading.stop();
  };

  async function handleGetFiles() {
    loading.start();

    fitinsur.requestGetDocuments(props.match.params.idOperation)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }

        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setWordingFile({
            dsTypeDocument: file.dsTypeDocument || "Wording",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return response.ret_value;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });


    fitinsur.requestGetDocuments(props.match.params.idOperation, true)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }
        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setWordingAttachmentFile({
            dsTypeDocument: file.dsTypeDocument || "Wording",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument,
          });
        } else {
          setWordingAttachmentFile({})
        }
        return response.ret_value;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });

    fitinsur.requestAttachAssumptions(props.match.params.idOperation)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }
        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setScheduleAssumptionsFile({
            dsTypeDocument: "Schedule",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });

    fitinsur.requestGetAttachment(props.match.params.idOperation, props.match.params.idPerson)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }
        if (response.ret_value.length > 0) {
          const file = response.ret_value[0];
          setAttachmentFile({
            dsTypeDocument: "",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          });
        }
        return;
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostReject - Error:', error);
      });
    loading.stop();
  }

  function handleImport() {
    const formData = new FormData();
    formData.append('fileDocument', rejectDocuments[0]);
    formData.append('idOperation', props.match.params.idOperation)

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestWordingUpload(formData)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error(res.ret_msg_details);
          loading.stop();
          return;
        }
      })
      .catch(err => {
        mc.error("An error happened, please try again");
        loading.stop();
      });
  };

  function handleWording() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGenerateWording(props.match.params.idOperation)
      .then(data => data.json())
      .then(resp => {
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          return;
        }
        history.push(`/broking/send-wording-request/${props.match.params.idOperation}`);
      })
      .catch(e => console.log(e));
  };

  async function handleOperationInfo() {
    loading.start()
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(props.match.params.idOperation)
      .then(response => response.json())
      .then(response => {
        setIsBound(response?.isBound);
        setIdProduct(response?.isDeclaration ? response?.idProduct : 12);
        loading.stop();
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
        loading.stop();
      });
  }
  
  useEffect(() => {
    if (formik) {
      formik.current?.setFieldValue('dealAnalisysInformation', handleHistoryMessage());
    }
    }, [historymsg])

  useEffect(() => { 
    if(idProduct == 12) { 
      history.push(`/broking/send-approval-pack/${props.match.params.idOperation}`)
    } else if(idProduct == 16) { 
      history.push(`/broking/send-approval-pack/${props.match.params.idOperation}`)
    }
  }, [idProduct])

  useEffect(() => {
    loading.start();
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      loading.stop();
      goToLoginPage();
      return;
    }
    else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    };

    handleGetModal();
    handleGetFiles();
    handleSummary();
    handleOperationInfo();
    //hideActionsButtons(summary.idDomainStatusPolicyPack);
    loading.stop();
  }, [])

  const endorsmentTypeEnum = {
    ['not-pre-agreed']: {
      title: 'Anniversary - Premium: Not Pre Agreed / Endorsement Pack Approval'
    },
    ['cancellation']: {
      title: 'Endorsement - Cancellation / Endorsement Pack Approval'
    }
  }

  const hideActionsButtons = (idDomainStatusPolicyPack) => {
    const idDomainStatusPolicyPackInternally = [41, 119, 144, 179, 206, 242, 274];
    const idDomainsStatusPolicyPackClient = [44];

    if (idDomainStatusPolicyPackInternally.includes(idDomainStatusPolicyPack)
      && props.permissions.APPROVE_REJECT_INTERNALLY) {
      return setHideButtons(true);
    }

    if (idDomainsStatusPolicyPackClient.includes(idDomainStatusPolicyPack)
      && props.permissions.APPROVE_REJECT_CLIENT) {
        return setHideButtons(true);
    }

    if (endorsmentType && props.permissions.ENDORSEMENT_PACK_APPROVE_REJECT) {
      return setHideButtons(true);
    }

    return setHideButtons(false);
  }

  useEffect(() => {
    hideActionsButtons(summary.idDomainStatusPolicyPack);
  }, [props?.permissions, summary?.idDomainStatusPolicyPack]);

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />
      <ContentCard title={endorsmentTypeEnum[endorsmentType] ? endorsmentTypeEnum[endorsmentType].title : "Approval Policy Pack"} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
          {typeDialog === 'Approve' ?
            <ContentTextarea>
              <p>Deal Analysis information</p>
              <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
              <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
              <DialogConfirm onClick={() => handleApproval()}>CONFIRM</DialogConfirm>
            </ContentTextarea>

            : typeDialog === 'Reject' ?
              <ContentTextarea>
                <p>Deal Analysis information</p>
                <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
                <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
                <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
              </ContentTextarea>
              : ""
          }
        </DialogComponent>

        <Formik
          innerRef={formik}
          initialValues={{
            dealAnalisysInformation: '',
            policyPackMessage: ''
          }}
          validationSchema={validation}
          onSubmit={() => { }}
        >
          {
            formikProps => (
              <Form>
                <Field
                  label='Policy Pack Message - (External)'
                  name={'policyPackMessage'}
                  value={formikProps.values.policyPackMessage}
                  onChange={(e) => formikProps?.setFieldValue('policyPackMessage', e)}
                  component={TextField}
                  disabled={true}
                />

                <FileModal idOperation={props?.match?.params?.idOperation} file={file} />

                {(wordingFile && wordingFile.nameFile )|| (scheduleAssumptionsFile && scheduleAssumptionsFile.nameFile)
                  || (wordingAttachmentFile && wordingAttachmentFile.nameFile) ?
                  <Col md={9} sm={1} style={{ marginBottom: 20 }}>
                    <Label>Attachments</Label>
                    <TagsList3
                      tags={[wordingAttachmentFile, wordingFile, scheduleAssumptionsFile, attachmentFile].filter(file => file.nameFile)}
                      disableType
                      hideTrash={true}
                    />
                  </Col>
                  : ''}

                {isClient ? '' :
                  <Col md={12} sm={1}>
                    <Field
                      readOnly
                      label={'Deal Analysis Information'}
                      name={'dealAnalisysInformation'}
                      value={handleHistoryMessage()}
                      onChange={(e) => formikProps?.setFieldValue('dealAnalisysInformation', e)}
                      component={TextField}
                    />
                  </Col>
                }
              </Form>
            )}
        </Formik>

        <ButtonContainer>
          <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
          {props.location?.state?.hideFooter ? '' :
            <HasPermission permission={!isBound}>
              <ButtonContent>
                {isReject ?
                  <HasPermission permission={props.permissions.GENERATE_WORDING}>
                    <Button
                      style={{ marginLeft: "10px" }}
                      primary
                      disabled={(attachmentFile && attachmentFile.nameFile)}
                      id="btnGoWording"
                      onClick={handleWording}
                    >
                      GENERATE WORDING
                    </Button>
                  </HasPermission>
                  :
                  <HasPermission permission={hideButtons}>
                    <Button
                      secundary
                      type="submit"
                      id="btnReject"
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Reject") }}
                    >
                      REJECT
                    </Button>
                    <Button
                      primary
                      type="submit"
                      id="btnSubmit"
                      style={{ marginLeft: "10px" }}
                      disabled={rejectDocuments?.length > 0 ? true : false}
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Approve") }}
                    >
                      APPROVE
                    </Button>
                  </HasPermission>
                }
              </ButtonContent>
            </HasPermission>
          }
        </ButtonContainer>
        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </ContentCard>
    </Layout>
  );
}